import React from 'react';

import S from './NotFound.module.css';

const NotFoundPage = () => {
  return <div className={S.root}>404: Not Found</div>;
};

export default NotFoundPage;
